// @ts-nocheck
import translate from "@insite/client-framework/Translate";
import Button from "@insite/mobius/Button";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import React from "react";
import { css } from "styled-components";

interface CreditFormButtonsProps {
    onNextStep?: () => void;
    onPreviousStep?: () => void;
    finalStep?: boolean;
    nextStepDisabled?: boolean;
    previousStepDisabled?: boolean;
    onFormSave?: () => void;
}
interface CreditFormButtonsStyles {
    button?: InjectableCss;
}

const creditFormButtonsStyles: CreditFormButtonsStyles = {
    button: {
        css: css`
            border-radius: ${pxToRem(4)};
        `,
    },
};

const CreditFormButtons: React.FC<CreditFormButtonsProps> = ({
    onNextStep,
    onPreviousStep,
    finalStep,
    nextStepDisabled,
    previousStepDisabled,
    onFormSave,
}) => {
    return (
        <>
            <Button disabled={previousStepDisabled} {...creditFormButtonsStyles.button} onClick={onPreviousStep}>
                {translate("Previous Step")}
            </Button>
            <Button onClick={onFormSave} {...creditFormButtonsStyles.button}>
                {translate("Save")}
            </Button>
            <Button {...creditFormButtonsStyles.button} onClick={onNextStep} disabled={nextStepDisabled}>
                {finalStep ? translate("Submit") : translate("Next Step")}
            </Button>
        </>
    );
};
export default CreditFormButtons;
